<template>
  <Modal :value="open" :close="close" size="tiny" :onClose="onClose" :title="title" :escToClose="escToClose">
    <div class="loading-modal">
      <div class="cogs">
        <svg class="cog" width="78px" height="78px" viewBox="0 0 78 78" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Layout" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Modal" transform="translate(-718.000000, -298.000000)" fill-rule="nonzero">
                  <g id="Group" transform="translate(523.000000, 198.000000)">
                      <g id="Gears" transform="translate(200.500000, 140.500000) scale(-1, 1) translate(-200.500000, -140.500000) translate(130.000000, 69.000000)">
                          <g id="settings" transform="translate(0.000000, 31.000000)">
                              <g id="Capa_1">
                                  <path d="M71.308,34.347 C64.3435,33.0075 61.15,24.87 65.344,19.152 L68.29,15.135 L61.9255,8.7705 L57.9685,11.451 C52.0975,15.429 44.0845,11.9325 43.0075,4.9245 L42.25,0 L33.25,0 L32.0845,6.0615 C30.775,12.8715 22.927,16.1235 17.185,12.234 L12.0745,8.7705 L5.71,15.135 L8.656,19.152 C12.85,24.87 9.655,33.0075 2.692,34.347 L-2,35.25 L-2,44.25 L2.9245,45.0075 C9.934,46.086 13.429,54.099 9.451,59.97 L6.7705,63.9255 L13.135,70.29 L17.152,67.344 C22.87,63.15 31.0075,66.3435 32.347,73.308 L33.25,78 L42.25,78 L42.7825,74.5365 C43.885,67.3725 52.1935,63.93 58.039,68.217 L60.865,70.29 L67.2295,63.9255 L64.549,59.97 C60.5725,54.099 64.0675,46.086 71.0755,45.0075 L76,44.25 L76,35.25 L71.308,34.347 Z M37.75,46.5 C34.0225,46.5 31,43.4775 31,39.75 C31,36.0225 34.0225,33 37.75,33 C41.4775,33 44.5,36.0225 44.5,39.75 C44.5,43.4775 41.4775,46.5 37.75,46.5 Z" id="Shape" fill="#C7CAC7"></path>
                                  <path d="M37.75,25.5 C29.8795,25.5 23.5,31.8795 23.5,39.75 C23.5,47.6205 29.8795,54 37.75,54 C45.6205,54 52,47.6205 52,39.75 C52,31.8795 45.6205,25.5 37.75,25.5 Z M37.75,46.5 C34.0225,46.5 31,43.4775 31,39.75 C31,36.0225 34.0225,33 37.75,33 C41.4775,33 44.5,36.0225 44.5,39.75 C44.5,43.4775 41.4775,46.5 37.75,46.5 Z" id="Shape" fill="#556080"></path>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        <svg class="cog" width="78px" height="78px" viewBox="0 0 78 78" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Layout" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Modal" transform="translate(-718.000000, -298.000000)" fill-rule="nonzero">
                  <g id="Group" transform="translate(523.000000, 198.000000)">
                      <g id="Gears" transform="translate(200.500000, 140.500000) scale(-1, 1) translate(-200.500000, -140.500000) translate(130.000000, 69.000000)">
                          <g id="settings" transform="translate(0.000000, 31.000000)">
                              <g id="Capa_1">
                                  <path d="M71.308,34.347 C64.3435,33.0075 61.15,24.87 65.344,19.152 L68.29,15.135 L61.9255,8.7705 L57.9685,11.451 C52.0975,15.429 44.0845,11.9325 43.0075,4.9245 L42.25,0 L33.25,0 L32.0845,6.0615 C30.775,12.8715 22.927,16.1235 17.185,12.234 L12.0745,8.7705 L5.71,15.135 L8.656,19.152 C12.85,24.87 9.655,33.0075 2.692,34.347 L-2,35.25 L-2,44.25 L2.9245,45.0075 C9.934,46.086 13.429,54.099 9.451,59.97 L6.7705,63.9255 L13.135,70.29 L17.152,67.344 C22.87,63.15 31.0075,66.3435 32.347,73.308 L33.25,78 L42.25,78 L42.7825,74.5365 C43.885,67.3725 52.1935,63.93 58.039,68.217 L60.865,70.29 L67.2295,63.9255 L64.549,59.97 C60.5725,54.099 64.0675,46.086 71.0755,45.0075 L76,44.25 L76,35.25 L71.308,34.347 Z M37.75,46.5 C34.0225,46.5 31,43.4775 31,39.75 C31,36.0225 34.0225,33 37.75,33 C41.4775,33 44.5,36.0225 44.5,39.75 C44.5,43.4775 41.4775,46.5 37.75,46.5 Z" id="Shape" fill="#C7CAC7"></path>
                                  <path d="M37.75,25.5 C29.8795,25.5 23.5,31.8795 23.5,39.75 C23.5,47.6205 29.8795,54 37.75,54 C45.6205,54 52,47.6205 52,39.75 C52,31.8795 45.6205,25.5 37.75,25.5 Z M37.75,46.5 C34.0225,46.5 31,43.4775 31,39.75 C31,36.0225 34.0225,33 37.75,33 C41.4775,33 44.5,36.0225 44.5,39.75 C44.5,43.4775 41.4775,46.5 37.75,46.5 Z" id="Shape" fill="#556080"></path>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        <svg class="cog" width="78px" height="78px" viewBox="0 0 78 78" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Layout" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Modal" transform="translate(-718.000000, -298.000000)" fill-rule="nonzero">
                  <g id="Group" transform="translate(523.000000, 198.000000)">
                      <g id="Gears" transform="translate(200.500000, 140.500000) scale(-1, 1) translate(-200.500000, -140.500000) translate(130.000000, 69.000000)">
                          <g id="settings" transform="translate(0.000000, 31.000000)">
                              <g id="Capa_1">
                                  <path d="M71.308,34.347 C64.3435,33.0075 61.15,24.87 65.344,19.152 L68.29,15.135 L61.9255,8.7705 L57.9685,11.451 C52.0975,15.429 44.0845,11.9325 43.0075,4.9245 L42.25,0 L33.25,0 L32.0845,6.0615 C30.775,12.8715 22.927,16.1235 17.185,12.234 L12.0745,8.7705 L5.71,15.135 L8.656,19.152 C12.85,24.87 9.655,33.0075 2.692,34.347 L-2,35.25 L-2,44.25 L2.9245,45.0075 C9.934,46.086 13.429,54.099 9.451,59.97 L6.7705,63.9255 L13.135,70.29 L17.152,67.344 C22.87,63.15 31.0075,66.3435 32.347,73.308 L33.25,78 L42.25,78 L42.7825,74.5365 C43.885,67.3725 52.1935,63.93 58.039,68.217 L60.865,70.29 L67.2295,63.9255 L64.549,59.97 C60.5725,54.099 64.0675,46.086 71.0755,45.0075 L76,44.25 L76,35.25 L71.308,34.347 Z M37.75,46.5 C34.0225,46.5 31,43.4775 31,39.75 C31,36.0225 34.0225,33 37.75,33 C41.4775,33 44.5,36.0225 44.5,39.75 C44.5,43.4775 41.4775,46.5 37.75,46.5 Z" id="Shape" fill="#C7CAC7"></path>
                                  <path d="M37.75,25.5 C29.8795,25.5 23.5,31.8795 23.5,39.75 C23.5,47.6205 29.8795,54 37.75,54 C45.6205,54 52,47.6205 52,39.75 C52,31.8795 45.6205,25.5 37.75,25.5 Z M37.75,46.5 C34.0225,46.5 31,43.4775 31,39.75 C31,36.0225 34.0225,33 37.75,33 C41.4775,33 44.5,36.0225 44.5,39.75 C44.5,43.4775 41.4775,46.5 37.75,46.5 Z" id="Shape" fill="#556080"></path>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
      </div>
      <h4>
        {{ subtitle }}
      </h4>
      <p>
        {{ information }}
      </p>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';

export default {
  name: 'ModalLoading',
  components: {
    Modal,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      required: true,
    },
    close: {
      type: Boolean,
      default: () => true,
      required: false,
    },
    escToClose: {
      type: Boolean,
      default: () => true,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    information: {
      type: String,
      required: false,
    },
  },
};
</script>

<style>
.loading-modal {
  padding: 30px 15px;
}
.loading-modal h4 {
  color: #59668c;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
}
.loading-modal p {
  margin: 15px auto 0;
  text-align: center;
}
.loading-modal .cogs {
  margin-bottom: 20px;
}
.loading-modal .cogs .cog:first-child,
.loading-modal .cogs .cog:nth-child(2) {
  animation: rotate 2s infinite linear;
  display: block;
  height: 58px;
  left: 50%;
  margin-left: -58px;
  position: relative;
  width: 58px;
}
.loading-modal .cogs .cog:first-child {
  margin-bottom: 10px;
}
.loading-modal .cogs .cog:last-child {
  animation: rotate 2s infinite linear;
  animation-direction: reverse;
  position: absolute;
  margin-top: -103px;
  left: 50%;
}
.btn.btn-close.btn-clean .container-button {
  display: inherit;
  color: black;
} 

@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
  }
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
  }
}
</style>
